import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-item-add-view',
  templateUrl: './item-add-view.component.html',
  styleUrls: ['./item-add-view.component.css']
})
export class ItemAddViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
